import React, { Component } from 'react';
import moment from 'moment';
import { Example, Properties, SourceCode } from 'examples';
import Application from '../Application/Application';
import Metadata from './Metadata';

import METADATA_DEFINITIONS from './metadataDefinitions';

const LOCALES = [
  { localeId: 'ar_AE', language: 'Arabic', country: 'United Arab Emirates' },
  { localeId: 'de_DE', language: 'German', country: 'Germany' },
  { localeId: 'en_US', language: 'English', country: 'United States', default: true },
  { localeId: 'es_ES', language: 'Spanish', country: 'Spain' },
  { localeId: 'no_NB', language: 'Norwegian', country: 'Norway' },
  { localeId: 'pt_PT', language: 'Portuguese', country: 'Portugal' },
];

const METADATA = {
  default: {
    date: moment('2020-01-01 12:00'),
    title: 'This is the untranslated title',
    textarea: 'This is a text area'
  },
  ar_AE: {
    title: 'هذا هو عنوان العربية',
  },
  en_US: {
    title: 'This is the English title',
    selectMultipleDynamic: 'Sports'
  },
  no_NB: {
    title: 'Dette er den norske tittelen',
  },
};

const suggestions = ['test', 'autocomplete', 'suggestion', 'one', 'two', 'four', 'six', 'eight', 'ten', 'blue', 'gray'];

export default class MetadataExample extends Component {

  constructor(props) {
    super(props);

    const selected = LOCALES.find(locale => locale.default).localeId;

    this.state = {
      locales: LOCALES,
      allowWrite: true,
      metadata: METADATA,
      metadataDefinitions: METADATA_DEFINITIONS,
      selected,
      showAdd: true,
      suggestions: {},
    };
  }

  onSuggest = (key, options) => {
    this.setState({
      suggestions: {
        ...this.state.suggestions,
        [key]: suggestions,
      },
    });
  };

  onRemoveLocale = (e, nextMetadata, nextSelected) => {
    const locale = e.target.value;

    window.showAppInfo(`remove ${locale.language}`);
    if (!nextSelected) {
      Application.showDialog(`Unable to remove ${locale.language}`, 'Cannot remove the last language.', 'OK');
    } else {
      Application.showDialog(`Remove ${locale.language}?`, `Remove all ${locale.language.toLowerCase()} translations for this item?`, 'Yes', 'No',
        () => {
          this.setState({
            metadata: nextMetadata,
            selected: nextSelected,
          });
        });
    }
  };

  onChangeLocale = e => {
    this.setState({ selected: e.target.value.localeId });
    window.showAppInfo(e.target.value.language);
  };

  onChangeProperties = e => {
    this.setState(e.target.value);
  };

  onChange = e => {
    this.setState({ metadata: e.target.value });
  };

  render() {
    return (
      <Example {...this.props}>
        <Properties defaultProps={Metadata.defaultProps} propTypes={Metadata.propTypes} propValues={this.state}
          onChange={this.onChangeProperties}/>
        <Metadata {...this.state} onChangeLocale={this.onChangeLocale} onRemoveLocale={this.onRemoveLocale}
          onChange={this.onChange} onSuggest={this.onSuggest}/>
        <SourceCode querySelector=".page-metadata .core-metadata"/>
      </Example>
    );
  }

}
